import React from 'react';
import { tomos } from '../data/content';
import { Reveal } from './Reveal';
const TACTICS_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/d9de31ca-3788-4198-bd6e-9d874501f76f.jpg';
export function WhatIsIt() {
  return <section className="bg-paper-soft px-5 py-20 sm:py-28 lg:px-8" aria-labelledby="que-es" data-id="element-186" data-mp="3k9oq3kdwhfbl">
      <div className="mx-auto max-w-6xl" data-id="element-187" data-mp="3p9azfiqlybf4">
        <div className="grid items-end gap-10 lg:grid-cols-[1.2fr_1fr]" data-id="element-188" data-mp="gqve3c0rsyjj">
          <Reveal data-id="element-189" data-mp="ksz2104mlvlp">
            <p className="text-[11px] font-extrabold uppercase tracking-[0.28em] text-grass" data-id="element-190" data-mp="kti89jkwyvjw">
              Qué es el megapack
            </p>
            <h2 id="que-es" className="display mt-4 text-4xl text-ink sm:text-5xl lg:text-[3.75rem]" data-id="element-191" data-mp="712c92qfjxsh">
              6 tomos tácticos + un manual maestro
            </h2>
            <p className="mt-6 max-w-readable text-lg leading-relaxed text-ink-soft" data-id="element-192" data-mp="zoy7s449jjno">
              Diseñado para el barro de la Argentina. Nada de tácticas europeas
              imposibles de aplicar con 20 pibes y cuatro conos.{' '}
              <span className="font-semibold text-ink" data-id="element-193" data-mp="3bzzuq5vwq296">Esto es fútbol real.</span>
            </p>
          </Reveal>

          <Reveal delay={0.06} data-id="element-194" data-mp="3prec68a61ve4">
            <img src={TACTICS_IMAGE} alt="Pizarra táctica con diagramas dibujados a mano, silbato y conos sobre el césped" className="w-full rounded-xl object-cover shadow-lg" data-id="element-195" data-mp="3pspfk6zp914p" />
          </Reveal>
        </div>

        <div className="mt-16 grid gap-6 sm:grid-cols-3" data-id="element-196" data-mp="3ur0psitwpdng">
          {tomos.map((tomo, i) => <Reveal key={tomo.title} delay={i * 0.05} className="h-full" data-id="element-197" data-mp="cl4fi1kmqk70" data-mpi={i}>
              <article className="flex h-full flex-col rounded-xl border border-paper-line bg-paper p-7" data-id="element-198" data-mp="7li4lys9xg1d">
                <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-grass" data-id="element-199" data-mp="2ebpp7gwwwwdb">
                  {tomo.tag}
                </p>
                <h3 className="display mt-3 text-3xl text-ink" data-id="element-200" data-mp="29e6akfwayhku">{tomo.title}</h3>
                <p className="mt-4 text-[15px] leading-relaxed text-ink-soft" data-id="element-201" data-mp="dajjdtnbn4y5">
                  {tomo.body}
                </p>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}